const OTHER_SUBCATEGORY = 'Other';

module.exports = {
  OTHER_SUBCATEGORY,
};
